import * as React from 'react'
import { SortableContainer, SortableElement } from 'react-sortable-hoc'
import { arrayMoveImmutable } from 'array-move'
import { riderService } from '../../services/Rider'
import { tripService } from '../../services/Trip'
import { serviceEntityService } from '../../services/Service'
import { importTemplateService } from '../../services/Import'
import { TripStatuses } from '../../constants/trip-statuses'

const alphabets = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'

const getColumnName = (idx: number) => {
  return (Math.floor(idx / 26.0) ? alphabets[Math.floor(idx / 26.0) - 1] : '') + alphabets[idx % 26]
}

const SortableItem = SortableElement((props: any) => (
  <div className='bb-width-1 bb-style-solid' title={props.item.values}>
    <span className='mr1'>
      {Math.floor(props.item.idx / 26.0) ? alphabets[Math.floor(props.item.idx / 26.0) - 1] : ''}
      {alphabets[props.item.idx % 26]}
    </span>
    {props.item.name}
  </div>
))

const SortableList = SortableContainer((props: any) => {
  return (
    <div>
      {props.items.map((item: any, index: number) => (
        <SortableItem key={`item-${item.name}-${index}`} index={index} item={item} />
      ))}
    </div>
  )
})

export interface IImportTripProps {
  currentOrgId: string
}

export interface IImportTripState {
  headers: string[]
  fieldsMap: string[]
  csvFieldMap: object
  data: object[]
  loading: boolean
  logs: string[]
  service: string
  products: any[]
  services: any[]
  templates: any[]
  templateId: string
  productFieldMap: object
  tripNotesFieldMap: any[]
  profileNotesFieldMap: any[]
  detailsField: {
    authCode: any
    billingCode: any
    pickUpNote: any
    dropOffNote: any
    riderExternalId: any
  }
  showDeleteConfirm: boolean
}

let rollbackRiders: string[] = []
let rollbackTrips: string[] = []

class ImportTrip extends React.Component<IImportTripProps, IImportTripState> {
  constructor(props: IImportTripProps) {
    super(props)

    this.state = {
      headers: [],
      logs: [],
      csvFieldMap: {},
      fieldsMap: [
        'riderPhone',
        'riderFirstName',
        'riderLastName',
        'pickupAddress1',
        'pickupCity',
        'pickupState',
        'dropoffAddress1',
        'dropoffCity',
        'dropoffState',
        'productName',
        'scheduledPickupTime',
        'scheduledDropoffTime',
        'additionalPassengersCount'
      ],
      tripNotesFieldMap: [],
      profileNotesFieldMap: [],
      data: [],
      service: '',
      productFieldMap: {},
      products: [],
      services: [],
      templateId: '',
      templates: [],
      loading: true,
      detailsField: {
        authCode: null,
        billingCode: null,
        pickUpNote: null,
        dropOffNote: null,
        riderExternalId: null
      },
      showDeleteConfirm: false
    }

    this.onSortEnd = this.onSortEnd.bind(this)
    this.analyzeFile = this.analyzeFile.bind(this)
    this.process = this.process.bind(this)
    this.handleSaveTemplate = this.handleSaveTemplate.bind(this)
    this.selectTemplate = this.selectTemplate.bind(this)
    this.handleDeleteTemplate = this.handleDeleteTemplate.bind(this)
    this.requestDeleteTemplate = this.requestDeleteTemplate.bind(this)
    this.cancelDeleteTemplate = this.cancelDeleteTemplate.bind(this)
    this.confirmDeleteTemplate = this.confirmDeleteTemplate.bind(this)
  }

  public async componentDidMount() {
    const sres = await serviceEntityService.fetchServices('active', this.props.currentOrgId)

    const tres = await importTemplateService.getAll()

    this.setState({
      services: Object.values(sres.services),
      templates: tres.items.filter((item: any) => {
        const { orgId } = JSON.parse(item.fieldsmap)
        return !orgId || orgId === this.props.currentOrgId
      }),
      loading: false
    })
  }

  public render() {
    const {
      templateId,
      templates,
      fieldsMap,
      csvFieldMap,
      headers,
      logs,
      products,
      services,
      productFieldMap,
      service,
      tripNotesFieldMap,
      profileNotesFieldMap,
      loading,
      detailsField,
      showDeleteConfirm
    } = this.state
    const selectableItems = headers.filter(
      (item: any) =>
        Object.values(csvFieldMap).findIndex(mappedItem => mappedItem && mappedItem.idx === item.idx) === -1
    )
    const svc = services.find(s => s.name === service) || { id: undefined }

    const multipleFieldsMap = [
      {
        label: 'Trip Note',
        fieldsMap: tripNotesFieldMap,
        key: 'tripNotesFieldMap'
      },
      {
        label: 'Profile Note',
        fieldsMap: profileNotesFieldMap,
        key: 'profileNotesFieldMap'
      }
    ]

    const emptyProductMapptins = Object.values(productFieldMap).filter(v => !v).length
    const uploadDisabled = emptyProductMapptins > 0
    const baseButtonStyle = {
      border: '1px solid #c7c7c7',
      borderRadius: 4,
      padding: '6px 12px',
      fontSize: 13,
      cursor: loading ? 'not-allowed' : 'pointer',
      opacity: loading ? 0.65 : 1
    }
    const defaultButtonStyle = {
      ...baseButtonStyle,
      backgroundColor: '#f4f4f4',
      color: '#333'
    }
    const dangerButtonStyle = {
      ...baseButtonStyle,
      backgroundColor: '#d9534f',
      borderColor: '#c9302c',
      color: '#fff'
    }
    const cancelButtonStyle = {
      ...baseButtonStyle,
      backgroundColor: '#fff',
      color: '#333'
    }

    return (
      <div className='ml2'>
        <div className='select-file mb1'>
          <div>
            <label>Step 1: </label>
            <input disabled={loading} type='file' id='csv-file' onChange={this.analyzeFile} className='mr-2' />
          </div>
          <div className='flex mt1 mb2'>
            <label>Step 2: </label>
            <label className='mr1'>Template</label>
            <select disabled={loading} value={templateId} onChange={this.selectTemplate}>
              <option value=''>select template</option>
              {templates.map(t => {
                return (
                  <option key={t.id} value={t.id}>
                    {t.name}
                  </option>
                )
              })}
            </select>
            {!templateId && (
              <div>
                <input
                  disabled={loading}
                  type='text'
                  id='new-template-name'
                  style={{ marginLeft: '2px', height: '100%' }}
                />
              </div>
            )}
            <button className='mx1' style={defaultButtonStyle} onClick={this.handleSaveTemplate}>
              Save
            </button>
            {templateId && (
              <button style={dangerButtonStyle} onClick={this.requestDeleteTemplate}>
                Delete
              </button>
            )}
          </div>
        </div>
        <div className='field-map'>
          <div className='flex'>
            <div className='ml1'>
              {fieldsMap.map((f: string, fIdx: number) => {
                return (
                  <div key={f} className='flex mb1'>
                    <div className='mr-auto'>
                      <span className='mr1'>{fIdx + 1}</span>
                      {f}
                      &nbsp;&nbsp;
                    </div>
                    <select
                      disabled={loading}
                      value={csvFieldMap[fIdx] ? csvFieldMap[fIdx].idx : -1}
                      onChange={(ev: any) => {
                        const item: any = headers.find((h: any) => `${h.idx}` === `${ev.currentTarget.value}`)
                        if (!item) {
                          this.setState({
                            csvFieldMap: {
                              ...csvFieldMap,
                              [fIdx]: null
                            }
                          })
                          return
                        }
                        this.setState({
                          csvFieldMap: {
                            ...csvFieldMap,
                            [fIdx]: item
                          }
                        })
                        if (f === 'productName') {
                          this.initializeProductMap(item.idx)
                        }
                      }}
                      title={csvFieldMap[fIdx] && csvFieldMap[fIdx].values}
                    >
                      {csvFieldMap[fIdx] && (
                        <option value={csvFieldMap[fIdx].idx} title={csvFieldMap[fIdx].values}>
                          {csvFieldMap[fIdx] && getColumnName(csvFieldMap[fIdx].idx)}
                          &nbsp;&nbsp;
                          {csvFieldMap[fIdx].name}
                        </option>
                      )}
                      <option value={-1}>-</option>
                      {selectableItems.map((item: any) => {
                        return (
                          <option key={item.idx} value={item.idx} title={item.values}>
                            {getColumnName(item.idx)}
                            &nbsp;&nbsp;
                            {item.name}
                          </option>
                        )
                      })}
                    </select>
                  </div>
                )
              })}
              {multipleFieldsMap.map(mfm => {
                return (
                  <div className='flex mb1' key={mfm.key}>
                    <div className='mr-auto ml1'>{mfm.label}:</div>
                    <div className=''>
                      {(mfm.fieldsMap || []).map((field: any, fidx: number) => {
                        return (
                          <div key={fidx} className='flex'>
                            <select
                              disabled={loading}
                              value={field.idx}
                              onChange={ev => {
                                const item: any = headers.find((h: any) => `${h.idx}` === `${ev.currentTarget.value}`)
                                const tnfm = [...mfm.fieldsMap]
                                tnfm[fidx] = item
                                if (!item) {
                                  tnfm.splice(fidx, 1)
                                }
                                if (mfm.key === 'tripNotesFieldMap') {
                                  this.setState({ tripNotesFieldMap: tnfm })
                                } else {
                                  this.setState({ profileNotesFieldMap: tnfm })
                                }
                              }}
                            >
                              {field && (
                                <option value={field.idx} title={field.values}>
                                  {getColumnName(field.idx)}
                                  &nbsp;&nbsp;
                                  {field.name}
                                </option>
                              )}
                              <option value={-1}>-</option>
                              {headers.map((item: any) => {
                                return (
                                  <option key={item.idx} value={item.idx} title={item.values}>
                                    {getColumnName(item.idx)}
                                    &nbsp;&nbsp;
                                    {item.name}
                                  </option>
                                )
                              })}
                            </select>
                          </div>
                        )
                      })}
                      <div>
                        <select
                          disabled={loading}
                          value={-1}
                          onChange={ev => {
                            const item: any = headers.find((h: any) => `${h.idx}` === `${ev.currentTarget.value}`)
                            if (item) {
                              if (mfm.key === 'tripNotesFieldMap') {
                                this.setState({ tripNotesFieldMap: tripNotesFieldMap.concat(item) })
                              } else {
                                this.setState({ profileNotesFieldMap: profileNotesFieldMap.concat(item) })
                              }
                            }
                          }}
                        >
                          <option value={-1}>-</option>
                          {headers.map((item: any) => {
                            return (
                              <option key={item.idx} value={item.idx} title={item.values}>
                                {getColumnName(item.idx)}
                                &nbsp;&nbsp;
                                {item.name}
                              </option>
                            )
                          })}
                        </select>
                      </div>
                    </div>
                  </div>
                )
              })}
              <label>Extra details</label>
              {Object.keys(detailsField).map(f => {
                return (
                  <div key={f} className='flex mb1'>
                    <div className='mr-auto'>
                      {f}
                      &nbsp;&nbsp;
                    </div>
                    <select
                      disabled={loading}
                      value={detailsField[f] ? detailsField[f].idx : -1}
                      onChange={(ev: any) => {
                        const item: any = headers.find((h: any) => `${h.idx}` === `${ev.currentTarget.value}`)
                        if (!item) {
                          this.setState({
                            detailsField: {
                              ...detailsField,
                              [f]: -1
                            }
                          })
                          return
                        }
                        this.setState({
                          detailsField: {
                            ...detailsField,
                            [f]: item
                          }
                        })
                      }}
                      title={detailsField[f] && detailsField[f].values}
                    >
                      {detailsField[f] && (
                        <option value={detailsField[f].idx} title={detailsField[f].values}>
                          {detailsField[f] && getColumnName(detailsField[f].idx)}
                          &nbsp;&nbsp;
                          {detailsField[f].name}
                        </option>
                      )}
                      <option value={-1}>-</option>
                      {headers.map((item: any) => {
                        return (
                          <option key={item.idx} value={item.idx} title={item.values}>
                            {getColumnName(item.idx)}
                            &nbsp;&nbsp;
                            {item.name}
                          </option>
                        )
                      })}
                    </select>
                  </div>
                )
              })}
            </div>
            <div className='flex flex-column'>
              <div className='ml1 mb1 flex flex-column'>
                <label>Service</label>
                <select
                  disabled={loading}
                  value={svc.id}
                  onChange={ev => {
                    const svc = services.find(s => s.id === ev.target.value)
                    this.setState({
                      service: svc.name
                    })
                    this.loadServiceProducts(svc.id)
                  }}
                >
                  <option value={undefined}>-</option>
                  {services.map(service => {
                    return (
                      <option key={service.id} value={service.id}>
                        {service.name}
                      </option>
                    )
                  })}
                </select>
              </div>
              <div className='ml1 flex flex-column'>
                <label>Product field map</label>
                <div>
                  {Object.keys(productFieldMap).map(cValue => {
                    return (
                      <div className='flex' key={cValue}>
                        <label className='mr-auto'>{cValue}</label>
                        <select
                          disabled={loading}
                          value={productFieldMap[cValue]}
                          onChange={ev => {
                            this.setState({
                              productFieldMap: {
                                ...productFieldMap,
                                [cValue]: ev.target.value
                              }
                            })
                          }}
                        >
                          <option value={undefined}>-</option>
                          {products.map(product => {
                            return (
                              <option key={product.id} value={product.name}>
                                {product.name}
                              </option>
                            )
                          })}
                        </select>
                      </div>
                    )
                  })}
                </div>
                {emptyProductMapptins > 0 && <span className='red-font'>Please fill up all mappings.</span>}
              </div>
            </div>
            <div className='ml1 overflow-auto'>
              Logs...
              <pre>{logs.join('\n')}</pre>
            </div>
            <div>
              <button disabled={loading} onClick={this.rollbackProcess}>
                Rollback
              </button>
            </div>
          </div>
          <button disabled={loading || uploadDisabled} onClick={this.process}>
            Upload
          </button>
        </div>
        {showDeleteConfirm && (
          <div
            role='dialog'
            aria-modal='true'
            aria-labelledby='delete-template-modal-title'
            style={{
              position: 'fixed',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.45)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000
            }}
          >
            <div
              style={{
                background: '#fff',
                minWidth: 360,
                maxWidth: 520,
                padding: 16,
                borderRadius: 8,
                boxShadow: '0 10px 30px rgba(0,0,0,0.25)'
              }}
            >
              <h3 id='delete-template-modal-title' style={{ marginTop: 0 }}>
                Delete import template?
              </h3>
              <p>Are you sure you want to delete this import template? This action cannot be undone.</p>
              <div className='flex justify-end mt2'>
                <button className='mr2' style={cancelButtonStyle} onClick={this.cancelDeleteTemplate}>
                  Cancel
                </button>
                <button style={dangerButtonStyle} onClick={this.confirmDeleteTemplate}>
                  Delete Template
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

  private requestDeleteTemplate() {
    this.setState({ showDeleteConfirm: true })
  }

  private cancelDeleteTemplate() {
    this.setState({ showDeleteConfirm: false })
  }

  private async confirmDeleteTemplate() {
    await this.handleDeleteTemplate()
    this.setState({ showDeleteConfirm: false })
  }

  private async handleDeleteTemplate() {
    if (!this.state.templateId) {
      this.setState({ showDeleteConfirm: false })
      return
    }
    await importTemplateService.deleteImportTemplate(this.state.templateId)

    this.setState({
      templateId: '',
      csvFieldMap: [],
      productFieldMap: {},
      tripNotesFieldMap: [],
      service: '',
      templates: this.state.templates.filter(t => t.id !== this.state.templateId),
      detailsField: {
        authCode: null,
        billingCode: null,
        pickUpNote: null,
        dropOffNote: null,
        riderExternalId: null
      },
      showDeleteConfirm: false
    })
  }

  private async handleSaveTemplate() {
    const { csvFieldMap, productFieldMap, profileNotesFieldMap, service, tripNotesFieldMap, detailsField } = this.state
    if (this.state.templateId) {
      const st = this.state.templates.find(t => t.id === this.state.templateId)
      const orgId = this.props.currentOrgId
      const template = {
        id: this.state.templateId,
        name: st.name,
        fieldsmap: JSON.stringify({
          orgId,
          csvFieldMap,
          productFieldMap,
          tripNotesFieldMap,
          profileNotesFieldMap,
          service,
          detailsField
        })
      }
      await importTemplateService.updateImportTemplate(template)
    } else {
      const el: any = document.body.querySelector('#new-template-name')
      const orgId = this.props.currentOrgId
      if (!el) {
        return
      }
      const name = el.value
      if (!name) {
        el.focus()
      }
      const { templates } = this.state
      const template: any = await importTemplateService.createImportTemplate({
        name,
        fieldsmap: JSON.stringify({
          orgId,
          csvFieldMap,
          productFieldMap,
          tripNotesFieldMap,
          service,
          detailsField
        })
      })
      console.log('template: ', template)
      this.setState({
        templates: templates.concat(template),
        templateId: template.id
      })
    }
  }

  private async selectTemplate(ev: any) {
    const tId = ev.target.value
    const template = this.state.templates.find(t => t.id === tId)
    if (!template) {
      this.setState({
        templateId: '',
        csvFieldMap: [],
        productFieldMap: {},
        tripNotesFieldMap: [],
        service: ''
      })
      return
    }
    const { csvFieldMap, productFieldMap, profileNotesFieldMap, service, tripNotesFieldMap, detailsField } = JSON.parse(
      template.fieldsmap
    )
    const svc = this.state.services.find(s => s.name === service)
    const initialProductFieldsMap: any = {}
    if (svc) {
      await this.loadServiceProducts(svc.id)
      const productColumnIndex = csvFieldMap[9].idx
      this.state.data.forEach((row: string[]) => {
        initialProductFieldsMap[row[productColumnIndex]] = null
      })
    }
    this.setState({
      templateId: tId,
      csvFieldMap,
      productFieldMap: {
        ...initialProductFieldsMap,
        ...productFieldMap
      },
      tripNotesFieldMap: tripNotesFieldMap || [],
      profileNotesFieldMap: profileNotesFieldMap || [],
      service: svc ? svc.name : '',
      detailsField: {
        authCode: null,
        billingCode: null,
        pickUpNote: null,
        dropOffNote: null,
        ...(detailsField || {})
      }
    })
  }

  private async loadServiceProducts(serviceId: string) {
    const resp = await serviceEntityService.fetchServiceMainInfo(serviceId)
    this.setState({
      products: resp.services[serviceId].providerProducts || []
    })
  }

  private initializeProductMap(columnIdx: number) {
    const data: any = {}
    this.state.data.forEach((row: string[]) => {
      data[row[columnIdx]] = null
    })
    this.setState({
      productFieldMap: data
    })
  }

  private onSortEnd(idxs: any) {
    this.setState({
      headers: arrayMoveImmutable(this.state.headers, idxs.oldIndex, idxs.newIndex)
    })
  }

  private analyzeFile(ev: any) {
    this.setState({ headers: [], data: [], loading: true })
    const self = this
    const input = ev.target.files[0]
    const reader = new FileReader()

    reader.onload = (e: any) => {
      const text = e.target.result
      const colCount = text.slice(0, text.indexOf('\n')).split(',').length
      const rows: any[] = []
      let oneRow: string[] = []
      let colC = 0
      let quoteLvl = 0
      let word = ''
      const chars = text.slice(text.indexOf('\n') + 1).split('')
      chars.forEach((char: string, idx: number) => {
        if (char === '"') {
          quoteLvl = 1 - quoteLvl
        }
        if (
          (char === ',' && quoteLvl === 0) ||
          (char === '\n' && quoteLvl === 0 && colC === colCount - 1) ||
          idx === chars.length - 1
        ) {
          oneRow.push(word)
          word = ''
          colC = colC + 1
          if (colC === colCount) {
            rows.push(oneRow)
            oneRow = []
            colC = 0
          }
        } else {
          word += char
        }
      })
      const headers = text
        .slice(0, text.indexOf('\n'))
        .split(',')
        .map((f: string, idx: number) => ({
          name: f,
          idx,
          values: rows
            .slice(0, 10)
            .map((r: string[]) => r[idx])
            .join('\n')
        }))

      self.setState({ headers, data: rows, loading: false })
    }

    reader.readAsText(input)
  }

  private async process() {
    rollbackRiders = []
    rollbackTrips = []
    const {
      fieldsMap: originalFirldsMap,
      csvFieldMap,
      tripNotesFieldMap,
      profileNotesFieldMap,
      headers,
      detailsField
    } = this.state
    const fieldsMap: any = {}
    originalFirldsMap.forEach((field: string, idx: number) => {
      fieldsMap[field] = csvFieldMap[idx] ? csvFieldMap[idx].idx : -1
    })
    console.log('fieldsMap: ', fieldsMap)
    const orgId = this.props.currentOrgId

    const preparedData = []
    let rowIndex = 0
    for (const row of this.state.data) {
      rowIndex++
      const rowData: any = {}
      Object.keys(fieldsMap).forEach((field: string) => {
        rowData[field] = row[fieldsMap[field]].replace(/^("|')+/, '').replace(/("|')+$/, '')
        switch (field) {
          case 'productName':
            rowData[field] = this.state.productFieldMap[row[fieldsMap[field]]]
            break
          case 'scheduledPickupTime':
          case 'scheduledDropoffTime':
            try {
              rowData[field] = rowData[field] ? new Date(rowData[field]).toISOString() : ''
            } catch (err) {
              console.log('time handle err: ', err)
            }
            break
        }
      })
      rowData.details = Object.keys(this.state.detailsField).reduce((res, key) => {
        if (!this.state.detailsField[key]) {
          return res
        }
        return {
          ...res,
          [key]: row[this.state.detailsField[key].idx].replace(/^("|')+/, '').replace(/("|')+$/, '')
        }
      }, {})
      rowData.serviceName = this.state.service
      if (!rowData.riderPhone && !rowData.riderFirstName && !rowData.riderLastName) {
        this.setState({
          logs: this.state.logs.concat(`Skip empty row: ${rowIndex}`)
        })
        continue
      }
      console.log('rowData: ', rowData)

      const riderName = (rowData.riderFirstName + ' ' + (rowData.riderLastName || '') + '')
        .replace(/""/g, '')
        .replace(/''/g, '')
      const nameParts = riderName.split(' ').filter(s => !!s)
      const firstName = nameParts[0]
      const lastName = nameParts.slice(1).join(' ')
      const profileNote = profileNotesFieldMap.map(f => row[f.idx]).join(' ')
      const service = this.state.service
      const riderPhone = rowData.riderPhone
      let riderId = ''
      const riderUserName = firstName[0] + lastName + riderPhone.replace(/\D/g, '')
      const externalId = rowData.details.riderExternalId || null
      try {
        const rider = await riderService.getOneByUsername(riderUserName)
        riderId = rider.id
        this.setState({ logs: this.state.logs.concat(`INFO ROW: ${rowIndex} : rider found: ${riderId}`) })
      } catch (err) {
        this.setState({
          logs: this.state.logs.concat(
            `ERROR ROW: ${rowIndex} : rider ${riderUserName} not found - attempting to create: ${err.data}`
          )
        })
        const riderCreatePayload = {
          token: '53f2f470d4xx082f78cc58c8b1485bf6a316d9dnd39f432a1dd86f6277a4f53f',
          rider: {
            ownerOrganization: orgId,
            firstName,
            lastName,
            externalId,
            notificationPreference: 'text',
            username: riderUserName,
            note: profileNote,
            phones: [{ phoneNumber: riderPhone, countryCode: '1', isPrimary: true }]
          },
          services: [service]
        }
        console.log('riderImport payload: ', riderCreatePayload)

        try {
          const responseObject = await riderService.riderImport(riderCreatePayload)
          riderId = responseObject.rider.id
          rollbackRiders.push(responseObject.rider.id)
          this.setState({
            logs: this.state.logs.concat(`INFO ROW: ${rowIndex} : rider not found - created new one: ${riderId}`)
          })
        } catch (err) {
          console.log('rider handle err: ', err)
          this.setState({
            logs: this.state.logs.concat(`ERROR ROW: ${rowIndex} : rider failed to create: ${err.data}`)
          })
          continue
        }
      }

      const updateExternalIdPayload = {
        token: '53f2f470d4xx082f78cc58c8b1485bf6a316d9dnd39f432a1dd86f6277a4f53f',
        id: riderId,
        externalId
      }

      try {
        const riderInfo = await riderService.getRiderPersonalInfo(riderId)
        if (externalId) {
          if (riderInfo && riderInfo.externalId) {
            this.setState({
              logs: this.state.logs.concat(
                `INFO ROW: ${rowIndex} : External id exist, it will not be updated or overwritten.`
              )
            })
          } else {
            const riderExternalIdResponse = await riderService.riderImportExternalId(updateExternalIdPayload)
            console.log('External Id processed', riderExternalIdResponse)
            this.setState({
              logs: this.state.logs.concat(`INFO ROW: ${rowIndex} : external id processed : ${riderExternalIdResponse}`)
            })
          }
        }
      } catch (e) {
        console.log('External Id failed')
        this.setState({ logs: this.state.logs.concat(`ERROR ROW: ${rowIndex} : external id processe failed : ${e}`) })
      }

      const updateMembershipPayload = {
        token: '53f2f470d4xx082f78cc58c8b1485bf6a316d9dnd39f432a1dd86f6277a4f53f',
        riderId,
        orgId,
        services: [service]
      }

      try {
        const membershipAssignResponse = await riderService.riderImportMemberships(updateMembershipPayload)
        console.log('Memberships processed', membershipAssignResponse)
        this.setState({
          logs: this.state.logs.concat(
            `INFO ROW: ${rowIndex} : service membership processed : ${membershipAssignResponse}`
          )
        })
      } catch (e) {
        console.log('Memberships failed')
        this.setState({
          logs: this.state.logs.concat(`ERROR ROW: ${rowIndex} : service membership processe failed : ${e}`)
        })
      }

      const tripNotes = tripNotesFieldMap.map(f => row[f.idx]).join(' ')

      preparedData.push({
        ...rowData,
        orgId,
        field8: riderId,
        notes: tripNotes,
        details: {
          ...rowData.details,
          originalPickAddr: rowData.pickupAddress1,
          originalDropAddr: rowData.dropoffAddress1
        }
      })
    }

    try {
      this.setState({ logs: this.state.logs.concat(`INFO: Overall trip import started. ${new Date()}`) })
      const response = await tripService.importTripsJson({ data: preparedData })
      console.log('response: ', response)
      this.setState({ logs: this.state.logs.concat(`INFO: Trip import finished. ${new Date()}`) })
      this.setState({ logs: this.state.logs.concat(`RESULT:`) })
      const errors = response.data.errors || []
      errors.forEach((row: any) => {
        this.setState({ logs: this.state.logs.concat(`ROW: ${row.row + 1} : ${row.error}`) })
      })
      const trips = response.data.trips || []
      trips.forEach((row: any) => {
        this.setState({ logs: this.state.logs.concat(`ROW: ${row.row + 1} : ${row.trip_id}`) })
        rollbackTrips.push(row.trip_id)
      })
    } catch (e) {
      this.setState({ logs: this.state.logs.concat(`ERROR Trip import failed : ${e.data}`) })
    }
  }

  private async rollbackProcess() {
    // delete new riders created.

    for (const id of rollbackRiders) {
      try {
        await riderService.deleteRider(id)
      } catch (err) {
        console.log('rider delete err: ', err)
      }
    }

    for (const tripId of rollbackTrips) {
      try {
        await tripService.updateStatus(tripId, 'trip import rollback', TripStatuses.CANCELLED)
      } catch (err) {
        console.log('trip cancel err: ', err)
      }
    }
  }
}

export default ImportTrip



// WEBPACK FOOTER //
// ./src/components/import/Import.tsx